export default "__VITE_ASSET__DTRdruBN__"